<template>
  <div class="cert-detail-wrapper">
    <div class="cert-wrapper">
      <img :src="certImg" class="cert-img" v-if="certImg" />
      <div class="rending-cert-wrapper" v-show="rendingCert">
        证书生成中...
      </div>
    </div>
    <div class="tips">
      <i class="icon icon-arrow-top"></i>
      <span>长按证书保存到手机</span>
    </div>
    <div class="btn-wrapper" v-if="showActionBtns">
      <div class="btn btn-my-works" @click="handleJumpMyWork">
        <i class="icon icon-home"></i>
        <span>我的作品</span>
      </div>
      <div class="btn btn-my-works" @click="handleJumpCertGroup">
        <i class="icon icon-cert"></i>
        <span>全部证书</span>
      </div>
    </div>
    <div class="cert-tmp-wrapper" ref="certTmp">
      <component
        :is="renderCert()"
        :certType="certDetail.certType"
        :certName="certDetail.certName"
        :activityName="certDetail.activityName"
        :certContent="certDetail.certContent"
        :guideCompanyLabel="certDetail.guidanceTitle"
        :guideCompany="certDetail.guidance"
        :organizerLabel="certDetail.sponsorTitle"
        :organizer="certDetail.sponsor"
        :prizeName="certDetail.prizeName"
        :encourageText="certDetail.encourageText"
        :qrCodeUrl="qrCodeUrl"
        :author="certDetail.userName"
        :publicDate="certDetail.resolveCreateTime"
      ></component>
    </div>
    <!-- <div id="goushi">
      <CertificateEntry />
    </div> -->
  </div>
</template>

<script>
import CertificateEntry from "./components/CertificateTmp/CertificateEntry"
import CertificateEntryReward from "./components/CertificateTmp/CertificateEntryReward"
import CertificateReward from "./components/CertificateTmp/CertificateReward"
import { getCertDetail } from "@/server/interfaces"
import html2canvas from "html2canvas"
import { mapActions, mapGetters, mapMutations } from "vuex"
import resolveCertContent from "@/utils/resolveCertContent"
import renderQrCode from "@/utils/renderQrcode"
import getParamsFromUrl from "@/utils/getParamsFromUrl"
import { loadImg } from "@/utils/helpers"
import formatDate from "@/utils/formatDate"

const CERT_ENTRY_BG = require("./components/CertificateTmp/images/entryBg.png")
const CERT_REWARD_BG = require("./components/CertificateTmp/images/rewardBg.png")
const CERT_BG_MAP = {
  ENTRY_NORMAL: CERT_ENTRY_BG,
  ENTRY_EXCELLENT: CERT_ENTRY_BG,
  EXCELLENT_AWARD: CERT_REWARD_BG
}

export default {
  name: "certDetail",
  props: {},
  data() {
    return {
      certId: "",
      certType: "",
      certImg: "",
      certDetail: {
        certName: "证书名称",
        activityName: "活动名称",
        certContent: "我是证书正文",
        guidanceTitle: "指导单位",
        guidance: "指导单位名称",
        sponsorTitle: "主办单位",
        sponsor: "主办单位名称",
        prizeName: "十分优秀",
        encourageText: "获奖提示"
      },
      qrCodeUrl: "",
      rendingCert: false
    }
  },
  methods: {
    ...mapMutations({
      showToast: "toast/showToast",
      setShareInfo: "activityInfo/setShareInfo"
    }),
    ...mapActions({
      getNfplusUserInfo: "userInfo/getNfplusUserInfo",
      getUserDetail: "userInfo/getUserDetail",
      getActivityInfo: "activityInfo/getActivityInfo",
      initShareInfo: "activityInfo/initShareInfo"
    }),
    renderCert() {
      switch (this.certType) {
        case "ENTRY_NORMAL":
          return CertificateEntry
        case "ENTRY_EXCELLENT":
          return CertificateEntryReward
        case "EXCELLENT_AWARD":
          return CertificateReward
        default:
          return null
      }
    },
    _getCertId() {
      const certId = this.$route.query.certId || getParamsFromUrl().certId
      this.certId = certId
    },
    async _getCertDetail() {
      if (!this.certId) return
      const params = {
        certId: this.certId
      }
      const certDetail = await getCertDetail({ params })
      this.certType = certDetail.activityCertVO.certType
      const certInfo = {
        ...certDetail,
        ...certDetail.activityCertVO.certConfig,
        ...certDetail.activityCertVO,
        ...certDetail.content
      }
      certInfo.resolveCreateTime = formatDate(certInfo.createTime, "yyyy年MM月dd日")
      certInfo.certContent = resolveCertContent({
        content: certInfo.detail,
        activityName: certInfo.activityName,
        certDetail: certInfo.content
      })
      this.certDetail = certInfo
    },
    async _loadCertBg() {
      const certBg = CERT_BG_MAP[this.certType]
      const loadResult = await loadImg(certBg)
      return loadResult
    },
    async _loadQrcode() {
      if (!this.qrcodeUrl) return true
      const loadResult = await loadImg(this.qrCodeUrl)
      return loadResult
    },
    async renderCertImg() {
      this.rendingCert = true
      const loadCertBgResult = await this._loadCertBg()
      const loadQrcodeResult = await this._loadQrcode()
      if (!loadCertBgResult || !loadQrcodeResult) {
        this.showToast("证书生成失败，请刷新重试")
        return
      }
      this.$nextTick(() => {
        const certTmpDom = this.$refs.certTmp
        const options = {
          backgroundColor: "#ffffff",
          windowHeight: 3508,
          scale: 2.5
        }
        html2canvas(certTmpDom, options).then(async canvas => {
          this.certImg = canvas.toDataURL("image/jpeg", 1.0)
          this.rendingCert = false
        })
      })
    },
    handleJumpMyWork() {
      this.$router.push({ path: "/myWork" })
    },
    handleJumpCertGroup() {
      this.$router.push({ path: "/certGroup" })
    },
    async initQrCode() {
      let qrcodeUrl = this.myWorkCollectionUrl
      if (this.certType === "EXCELLENT_AWARD") {
        qrcodeUrl = this.workDetailUrl
      }
      const qrCodeOptions = {
        text: qrcodeUrl,
        width: 307 / 2.5
      }
      this.qrCodeUrl = await renderQrCode(qrCodeOptions)
    },
    hideNfPlusShareBtn() {
      const isFirstRoute = window.routerArr && window.routerArr.length < 2
      window.console.log("isFirstRoute", isFirstRoute)
      setTimeout(() => {
        isFirstRoute && window.nfplusJsbridge.hideShareButton(1)
      }, 1000)
    },
    async _initShareInfo() {
      if (!this.activityName) {
        await this.getActivityInfo({ notInitShare: true })
        const shareInfo = {
          title: this.activityDetailDesc.shareTitle,
          desc: this.activityDetailDesc.shareDesc,
          imgUrl: this.activityDetailDesc.shareIconUrl,
          link: `${window.location.origin}${window.location.pathname}?id=${this.activityId}`
        }
        this.setShareInfo(shareInfo)
        this.initShareInfo()
      }
    },
    async init() {
      this._getCertId()
      await this.getNfplusUserInfo()
      this._initShareInfo()
      await this.getUserDetail()
      await this._getCertDetail()
      await this.initQrCode()
      this.renderCertImg()
    }
  },
  components: {
    CertificateEntry,
    CertificateEntryReward,
    CertificateReward
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfo/userInfo",
      activityId: "activityInfo/activityId",
      activityName: "activityInfo/activityName",
      shareInfo: "activityInfo/shareInfo",
      activityDetailDesc: "activityInfo/activityDetailDesc"
    }),
    showActionBtns() {
      const isFirstRoute = window.routerArr && window.routerArr.length < 2
      return this.userInfo.userId && isFirstRoute
    },
    myWorkCollectionUrl() {
      return `${window.location.origin}${window.location.pathname}?id=${this.activityId}&route=workCollection&userId=${this.userInfo.userId}`
    },
    workDetailUrl() {
      return `${window.location.origin}${window.location.pathname}?id=${this.activityId}&route=workDetail&workId=${this.certDetail.worksId}`
    }
  },
  mounted() {
    // this.hideNfPlusShareBtn()
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.cert-detail-wrapper {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  &::before {
    content: "";
    display: block;
    height: 3.3rem;
    width: 3.3rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    background: url("../../assets/images/bg_top.png") no-repeat center;
    background-size: 100%;
  }
  &::after {
    content: "";
    display: block;
    height: 3.3rem;
    width: 3.3rem;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 0;
    background: url("../../assets/images/bg_bottom.png") no-repeat center;
    background-size: 100%;
  }
  > div {
    position: relative;
    z-index: 1;
  }
  .cert-wrapper {
    padding: 0.12rem;
    height: 9.44rem;
    width: 6.74rem;
    position: relative;
    background: #ffffff;
    box-shadow: 0 0 0.2rem 0 rgba(0, 0, 0, 0.2);
    border-radius: 0.02rem;
    .cert-img {
      display: block;
      height: 9.2rem;
      width: 6.5rem;
      -webkit-touch-callout: none;
      user-select: none;
    }
    .rending-cert-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 0.3rem;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }
  .tips {
    margin: 0.2rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    color: #333333;
    .icon-arrow-top {
      width: 0.24rem;
      height: 0.26rem;
      margin-right: 0.1rem;
      background: url("../../assets/images/icon_arrow_black.png") no-repeat center;
      background-size: 100%;
    }
  }
  .btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      background: #ffffff;
      border: 1px solid #fe5023;
      border-radius: 0.32rem;
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      color: #fe5023;
      line-height: 0.64rem;
      height: 0.64rem;
      padding: 0 0.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.4rem;
      &:last-child {
        margin-right: 0;
      }
      &:active {
        opacity: 0.7;
      }
      .icon {
        width: 0.44rem;
        height: 0.44rem;
        margin-right: 0.08rem;
        &.icon-home {
          background: url("../../assets/images/icon_works.png") no-repeat center;
          background-size: 100%;
        }
        &.icon-cert {
          background: url("../../assets/images/icon_certificate.png") no-repeat center;
          background-size: 100%;
        }
      }
    }
  }
  .cert-tmp-wrapper {
    position: fixed;
    top: 99999px;
    left: 99999px;
    z-index: 99999;
  }
}
</style>
